import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BREAKPOINTS_WIDTH } from './constants/breakpoint.constant';
import { isPlatformBrowser } from '@angular/common';
import { fromEvent } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ViewportService {
  platformId = inject(PLATFORM_ID);
  private viewportWidth = 0;

  constructor() {
    this.listenToResize();
  }

  listenToResize() {
    if (isPlatformBrowser(this.platformId)) {
      this.viewportWidth = window.innerWidth;

      fromEvent(window, 'resize').subscribe(() => {
        this.viewportWidth = window.innerWidth;
      });
    }
  }

  isMobileDevice(): boolean {
    return this.viewportWidth > 0 && this.viewportWidth < BREAKPOINTS_WIDTH.MOBILE;
  }

  isTabletDevice(): boolean {
    return this.viewportWidth >= BREAKPOINTS_WIDTH.MOBILE && this.viewportWidth < BREAKPOINTS_WIDTH.TABLET;
  }

  isDesktopDevice(): boolean {
    return this.viewportWidth >= BREAKPOINTS_WIDTH.TABLET;
  }
}
